export default class TrackedFlightView
{
	id = null
	code = null
	ownerId = null
	createdOn = null
	// this cant be in the array because firebase cant search it.
	track = null
	tracks = []

	get allTracks()
	{
		return this.tracks.concat([this.track])
	}

	static Track = class {
		userId = null
		userName = null
		userAvatar = null
		bearing = null
		photoId = null

		get photoUrl()
		{
			return `/api/tracking/photo?id=${this.photoId}`
		}
	}
}